import { EntityType } from "../../rl-common/shared/shared/entity-type.enum";
import { TagType } from "../shared/tag-type.type";

export class TagDisplay {

    name : string;
    code : string;
    type : TagType;
    entityType : string;
    order : string;
    get tagId() {
        return this.type + '_' + this.code;
    } 

    constructor(name : string, code : string, type : TagType, entityType : EntityType, order : string) {
        this.name = name;
        this.code = code;
        this.type = type;
        this.entityType = entityType;
        this.order = order;
    }
}
